<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import firebase from "firebase/app";
import "@firebase/auth";
import "@firebase/database";
import "@firebase/analytics";
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  name: "App"
};

// Firebase
var firebaseConfig = {
  apiKey: "AIzaSyAHJFa11suboK-fGE_5fC3TIhQ0urzDEJk",
  authDomain: "ilog-dpi.firebaseapp.com",
  databaseURL: "https://ilog-dpi.firebaseio.com",
  projectId: "ilog-dpi",
  storageBucket: "ilog-dpi.appspot.com",
  messagingSenderId: "935745084394",
  appId: "1:935745084394:web:945a6f8b377dfef3083093",
  measurementId: "G-LH7E7RVKHL"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
</script>

<style>
body {
  margin: 0%;
}
</style>
